<!-- <app-loader class="loader" [ngStyle]="{'display':displayStyles}"></app-loader> -->
<div class="body">
    <app-navbar></app-navbar>
    <div>
      <!-- <div class="heading-rounds-white">
          <h1><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">TRACKS</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
      </div> -->
      <div class="heading-rounds-white">
        <h1><span class="headi">TRACKS</span></h1>
      </div>
      <div class="criteria">
        <div *ngFor="let lis of lift">
          <div class="new">
            <div class="new2">
              <!-- <div class="header">
                          <h4>{{lis.title}}</h4>
                          <h4>{{lis.detail}}</h4>
                      </div> -->
              <div class="header">
                <h4 [class.small]="lis.title?.length > 30">{{ lis.title }}</h4>
              </div>
              <div class="imx">
                <img src="{{ lis.img }}" alt="" />
              </div>
              <div class="header">
                <!-- <h4>{{lis.title}}</h4> -->
                <h4 class="trackdetail">{{ lis.detail }}</h4>
              </div>
              <div class="new3">
                <h5>{{ lis.prize }}</h5>
                <p>{{ lis.desc }}</p>
              </div>
              <div class="knowmore">
                <div class="butbut">
                  <button
                    (click)="openPopup2(lis.knowmore)"
                    type="button"
                    class="btn know-more"
                  >
                    &nbsp; Know More &nbsp;
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="card"  *ngFor="let lis of lift" >
              <div class="card-in">
                  <img class="image" src="{{lis.img}}" alt="">
              </div>
              <div class="ace">
                  <h4>{{lis.title}}</h4>
                  <p>{{lis.desc}}</p>
                  <h5>{{lis.prize}}</h5>
                  <div class="butbut">
                      <button (click)="openPopup2(lis.knowmore)" type="button" class="btn btn-success know-more">Know More</button>
                  </div>
  
              </div>
              </div> -->
      </div>
    </div>
    <app-footer></app-footer>
    <!-- <app-footerblack></app-footerblack> -->
  </div>
  
  <!-- MODAL2 -->
  <!--   ADD TEAM MEMBER    -->
  
  <div
    style="z-index: 1"
    class="modal"
    tabindex="-1"
    role="dialog"
    [ngStyle]="{ display: displayStyle2 }"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content mode">
        <div class="modal-header">
          <div class="close" style="float: right; color: black">
            <img
              src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
              alt="close"
              (click)="closePopup2()"
            />
          </div>
          <h4 class="modal-title"><span class="headi">TRACK DETAILS</span></h4>
          <!-- <h4 class="modal-title">Register With E-Cell IIT Bombay {{this.idModal}}</h4> -->
        </div>
        <div
          class="member"
          style="color: black"
          [innerHTML]="this.knowmore"
          style="word-wrap: break-word; color: black"
        ></div>
        <div class="butbut">
          <button (click)="register()" type="button" class="btn know-more">
            &nbsp; Register Now &nbsp;
          </button>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
  